import React from "react";
import { useIntl } from "react-intl";
import { OccupancyGrid } from "../styles";
import { messages } from "../bookingForm.messages";
import { OccupancyState } from "../hooks/useOccupancyForm";
import { PropertyMaxOccupancy } from "../hooks/useBookingFormConfiguration";
import { OccupancyStepper } from "./OccupancyStepper";

interface TypeBasedOccupancyProps {
  occupancy: OccupancyState;
  maxOccupancy: PropertyMaxOccupancy;
  onStep: (key: keyof OccupancyState, delta: number, max: number) => void;
}

export function TypeBasedOccupancy({ occupancy, maxOccupancy, onStep }: TypeBasedOccupancyProps) {
  const intl = useIntl();

  const typeSelectors: { key: keyof OccupancyState; label: string; max?: number }[] = [
    { key: "adults", label: intl.formatMessage(messages.adults), max: maxOccupancy.maxAdults },
    { key: "juniors", label: intl.formatMessage(messages.juniors), max: maxOccupancy.maxJuniors },
    {
      key: "children",
      label: intl.formatMessage(messages.children),
      max: maxOccupancy.maxChildren,
    },
    { key: "babies", label: intl.formatMessage(messages.babies), max: maxOccupancy.maxBabies },
  ];

  return (
    <OccupancyGrid>
      {typeSelectors
        .filter(selector => (selector.max ?? 0) > 0)
        .map(selector => (
          <OccupancyStepper
            key={selector.key}
            label={selector.label}
            value={occupancy[selector.key]}
            max={selector.max ?? 0}
            onStep={delta => onStep(selector.key, delta, selector.max ?? 0)}
          />
        ))}
    </OccupancyGrid>
  );
}
